import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import {
  CreatorVideoModalContainer,
  ModalWrap,
  ModalContent,
  Video,
  TitleWrap,
  Title,
  IconWrap,
  BtnsWrap,
  CustomButton,
} from "./styled";
import { Icon } from "components/SvgIcons";
import Button from "shared/Button";
import { colors } from "styles/colors";
import { getMainVideo } from "../../../../helpers/video";

const ReplayIcon = () => (
  <svg id="replay" xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none">
    <path d="M6 5L11 8L6 11V5Z" fill="white" />
    <path d="M3.5 11V14H0.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <mask id="path-3-inside-1_19891_83855" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.21957 13.5296C-0.614037 10.5682 -0.750762 5.94422 1.90292 2.82059C4.55659 -0.303051 9.14203 -0.915678 12.5227 1.40175C15.9034 3.71918 16.9855 8.21682 15.0288 11.8182C13.4229 14.7738 10.1969 16.3409 7 15.9374"
      />
    </mask>
    <path
      d="M1.49704 14.2209C1.87886 14.6199 2.51188 14.6339 2.91091 14.2521C3.30995 13.8703 3.32391 13.2373 2.94209 12.8382L1.49704 14.2209ZM15.0288 11.8182L14.1501 11.3408L15.0288 11.8182ZM7.12522 14.9453C6.57728 14.8761 6.07703 15.2642 6.00787 15.8122C5.93871 16.3601 6.32684 16.8604 6.87478 16.9295L7.12522 14.9453ZM2.94209 12.8382C0.462728 10.247 0.343098 6.20117 2.66502 3.46803L1.14081 2.17314C-1.84462 5.68728 -1.6908 10.8893 1.49704 14.2209L2.94209 12.8382ZM2.66502 3.46803C4.98697 0.734878 8.99922 0.19882 11.9573 2.22657L13.0881 0.576936C9.28484 -2.03018 4.12621 -1.34098 1.14081 2.17314L2.66502 3.46803ZM11.9573 2.22657C14.9154 4.2543 15.8622 8.18966 14.1501 11.3408L15.9074 12.2956C18.1088 8.24398 16.8914 3.18406 13.0881 0.576936L11.9573 2.22657ZM14.1501 11.3408C12.7455 13.926 9.92301 15.2984 7.12522 14.9453L6.87478 16.9295C10.4709 17.3834 14.1004 15.6216 15.9074 12.2956L14.1501 11.3408Z"
      fill="white"
      mask="url(#path-3-inside-1_19891_83855)"
    />
  </svg>
);

const CreatorVideo = ({ item, onClose, toCreatorPage }) => {
  const [showBtns, setShowBtns] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    videoRef.current.onended = () => {
      setShowBtns(true);
    };
    videoRef.current.onplay = () => {
      setShowBtns(false);
    };
  }, []);

  const preventEvents = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };
  const replay = () => {
    setShowBtns(false);
    videoRef.current.play();
  };

  const { first_name, last_name } = item;

  return createPortal(
    <CreatorVideoModalContainer onClick={preventEvents}>
      <ModalWrap>
        <ModalContent>
          <TitleWrap>
            <Title>{`${first_name} ${last_name}'s`} Video Introduction</Title>
            <IconWrap>
              <Icon icon="close_2" onClick={onClose} />
            </IconWrap>
          </TitleWrap>
          <Video
            ref={videoRef}
            playsInline={true}
            src={getMainVideo(item)}
            controls
            controlsList="nodownload"
            onContextMenu={preventEvents}
          ></Video>
          <BtnsWrap>
            {showBtns && (
              <>
                <CustomButton onClick={replay}>
                  Replay
                  <ReplayIcon />
                </CustomButton>

                <Button
                  color={colors.RED}
                  stylType="primary"
                  iconRight="arrow_right"
                  text="View profile"
                  btnSize="larger"
                  onClick={() => toCreatorPage()}
                />
              </>
            )}
          </BtnsWrap>
        </ModalContent>
      </ModalWrap>
    </CreatorVideoModalContainer>,
    document.body
  );
};

export default CreatorVideo;
